import { z } from "zod";

const CreatePaymentSchema = z.object({
    date_payment: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, {
            message: "Date payment must be in YYYY-MM-DD format",
        }),
    payment_type: z.string().min(1, { message: "Payment type is required" }),
    amount: z.string().min(1, { message: "Amount is required" }),
    surcharge: z.string().min(1, {
        message: "Surcharge is required",
    }),
    booking_room_id: z.string().min(1, { message: "Booking room ID is required" }),
});

export { CreatePaymentSchema };
export type CreatePayment = z.infer<typeof CreatePaymentSchema>;